import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
export let CalciteStepperService = class CalciteStepperService {
    stepOptions = new BehaviorSubject([]);
    stepOptionsAsObservable = this.stepOptions.asObservable();
    stepIndex = new BehaviorSubject(0);
    stepIndexAsObservable = this.stepIndex.asObservable();
    totalSteps = 0;
    constructor() { }
    setStepIndex(index) {
        this.stepIndex.next(index);
    }
    setStepOptions(steps) {
        this.totalSteps = steps.length;
        this.stepOptions.next(steps);
    }
    getStepOptions() {
        return this.stepOptionsAsObservable;
    }
    updateStep(stepIndex, updatedStep) {
        const steps = this.stepOptions.value;
        if (steps && steps.length >= stepIndex) {
            steps[stepIndex] = updatedStep;
            this.stepOptions.next(steps);
        }
    }
    getStepByStepID(stepId) {
        let currentStep;
        this.stepOptions.value.forEach((step) => { if (step.stepId === stepId)
            currentStep = step; });
        // @ts-ignore
        return currentStep;
    }
    getStepByStepIndex(stepIndex) {
        return this.stepOptions.value[stepIndex];
    }
    static ctorParameters = () => [];
};
CalciteStepperService = __decorate([
    Injectable({
        providedIn: "root"
    })
], CalciteStepperService);
